// extracted by mini-css-extract-plugin
export default {"shimmerDiagonal":"style_shimmerDiagonal__0zoJV","shimmerDiagonalAnimation":"style_shimmerDiagonalAnimation__GDvtP"};